module.exports = __webpack_public_path__ + "assets/RhombusInRect.daab5e879a96ec1df7dac20f06f4de5e.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/RhombusInRect.gmt
// module id = 988
// module chunks = 0